import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=145ddaa7"
import script from "./InputCurrency.vue?vue&type=script&lang=ts"
export * from "./InputCurrency.vue?vue&type=script&lang=ts"
import style0 from "./InputCurrency.vue?vue&type=style&index=0&id=145ddaa7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports